// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ISxIZ","type":"styles_type__21rla","choices":"styles_choices__3Yao-"};